import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { CameraModelsJson } from '@hunting-nature/shared-core/interfaces/camera-models.interface';
import { Observable, shareReplay } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CameraModelService {
  // services
  private readonly http: HttpClient = inject(HttpClient);

  // private properties
  private readonly jsonConfigUrl: string = 'assets/camera-models.json';

  private readonly models$ = this.http.get<CameraModelsJson>(this.jsonConfigUrl).pipe(shareReplay({ bufferSize: 1, refCount: false }));

  public fetchCameraModels$(): Observable<CameraModelsJson> {
    return this.models$;
  }
}
